import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import GenericIdsSlice from '../Slicer/GenericIdsSlice';
import userReducer, { setupAuthStorageSync } from '../Slicer/userSlice'; // Import the new slice and sync function
import sessionReducer from '../Slicer/sessionSlice'; // Import session slice


const sopPersistConfig = {
    key: 'genic_ids',
    storage,
};

const userPersistConfig = {
    key: 'user',
    storage,
    version: 1,
};

const sessionPersistConfig = {
    key: 'session',
    storage,
    version: 1,
};

const persistedSopReducer = persistReducer(sopPersistConfig, GenericIdsSlice);
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedSessionReducer = persistReducer(sessionPersistConfig, sessionReducer);

const store = configureStore({
    reducer: {
        genic_ids: persistedSopReducer,
        user: persistedUserReducer, // Add the new slice to the reducer object
        session: persistedSessionReducer, // Add session slice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

const persistor = persistStore(store);

// Setup cross-tab auth sync
setupAuthStorageSync(store);

export { store, persistor };